<template>
  <div class="declaration-container">
    <header-index/>
    <div class="declaration-content">
      <div class="declaration-breadcrumb">
        <span>您当前位置：</span>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item
              :to="{ path: '/cloudPlatform/platform?city=2&cityName='+childNode.name+'&cityCode='+childNode.cityCode+'&parentCityCode='+childNode.parentCityCode+'&pName='+childNode.name+'企业数字化服务云平台&parName=渝企服务云' }">
            服务平台
          </el-breadcrumb-item>
          <el-breadcrumb-item>需求申报</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="declaration-info">
        <p class="declaration-title">{{ childNode.name }}企业服务诉求申报</p>
        <p class="declaration-tips">
          为贯彻习近平总书记重要讲话精神，落实党中央、国务院关于促进中小企业健康发展和提升中小企业专业化能力的决策部署，助力做好“六稳”工作、落实“六保”任务。重庆市促进中小企业发展服务中心按照主管单位重庆市经济和信息化委员会精准服务企业的要求，及时帮助企业解决经营发展中的具体问题，拟对全市企业重点服务需求进行诉求摸底，请各企业结合自己的经营实际认真填写需求信息，便于提供优质服务，促进其高质量发展。</p>
        <div class="declaration-menu">
          <el-descriptions class="margin-top" :column="1" border>
            <el-descriptions-item>
              <template slot="label">
                企业基本信息
              </template>
              <el-form :model="declarationForm" :rules="rules" label-position="right" ref="declarationForm1"
                       label-width="160px" class="declarationForm">
                <el-form-item label="企业名称：" prop="name">
                  <el-input v-model="declarationForm.name" style="width: 100%"/>
                </el-form-item>
                <el-form :inline="true" class="demo-form-inline" :rules="rules" :model="declarationForm"
                         label-width="160px"
                         label-position="right">
                  <el-form-item label="联系人：" prop="contacts">
                    <el-input v-model="declarationForm.contacts" style="width: 100%"/>
                  </el-form-item>
                  <el-form-item label="联系电话：" prop="phone">
                    <el-input v-model="declarationForm.phone" style="width: 100%"/>
                  </el-form-item>
                </el-form>
                <el-form-item label="所属行业：" prop="industry">
                  <el-cascader v-model="declarationForm.industry" :options="industryList" placeholder="请选择" clearable
                               style="width: 100%"/>
                </el-form-item>
                <el-form-item label="联系地址：" prop="address">
                  <el-input v-model="declarationForm.address" style="width: 100%" placeholder="请输入"/>
                </el-form-item>
                <el-form-item label="主营业务范围：" prop="business_scope">
                  <el-input v-model="declarationForm.business_scope" style="width: 100%" maxlength="1000"
                            type="textarea"
                            :autosize="{ minRows: 3, maxRows: 12}"/>
                </el-form-item>
              </el-form>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div class="declaration-menu">
          <el-descriptions class="margin-top" :column="1" border>
            <el-descriptions-item>
              <template slot="label">
                填写人的身份
              </template>
              <el-form :model="declarationForm" :rules="rules" ref="declarationForm2"
                       class="declarationForm2">
                <el-form-item prop="identity">
                  <el-radio-group v-model="declarationForm.identity">
                    <el-radio v-for="identity of identityList" :label="identity.label"
                              :value="identity.value"></el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-form>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div class="declaration-menu">
          <el-descriptions class="margin-top" :column="1" border>
            <el-descriptions-item>
              <template slot="label">
                企业对工商财税<br/>方面的需求<span class="small-title">（多选）</span>
              </template>
              <el-form :model="declarationForm" :rules="rules" ref="declarationForm3" class="declarationForm2">
                <el-form-item prop="taxation">
                  <el-checkbox-group v-model="declarationForm.taxation">
                    <el-checkbox v-for="item of taxationList" :label="item.label" :value="item.value"></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-form>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div class="declaration-menu">
          <el-descriptions class="margin-top" :column="1" border>
            <el-descriptions-item>
              <template slot="label">
                企业对知识产权<br/>方面的需求<span class="small-title">（多选）</span>
              </template>
              <el-form :model="declarationForm" :rules="rules" ref="declarationForm4" class="declarationForm2">
                <el-form-item prop="knowledge">
                  <el-checkbox-group v-model="declarationForm.knowledge">
                    <el-checkbox v-for="item2 of knowledgeList" :label="item2.label" :value="item2.value"></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-form>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div class="declaration-menu">
          <el-descriptions class="margin-top" :column="1" border>
            <el-descriptions-item>
              <template slot="label">
                企业对资质办理<br/>方面的需求<span class="small-title">（多选）</span>
              </template>
              <el-form :model="declarationForm" :rules="rules" ref="declarationForm5" class="declarationForm2">
                <el-form-item prop="qualifications">
                  <el-checkbox-group v-model="declarationForm.qualifications">
                    <el-checkbox v-for="item3 of qualificationsList" :label="item3.label"
                                 :value="item3.value"></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-form>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div class="declaration-menu">
          <el-descriptions class="margin-top" :column="1" border>
            <el-descriptions-item>
              <template slot="label">
                企业对人事服务<br/>方面的需求<span class="small-title">（多选）</span>
              </template>
              <el-form :model="declarationForm" :rules="rules" ref="declarationForm6" class="declarationForm2">
                <el-form-item prop="personnel_matters">
                  <el-checkbox-group v-model="declarationForm.personnel_matters">
                    <el-checkbox v-for="item4 of mattersList" :label="item4.label" :value="item4.value"></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-form>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div class="declaration-menu">
          <el-descriptions class="margin-top" :column="1" border>
            <el-descriptions-item>
              <template slot="label">
                企业对项目申报<br/>方面的需求<span class="small-title">（多选）</span>
              </template>
              <el-form :model="declarationForm" :rules="rules" ref="declarationForm7" class="declarationForm2">
                <el-form-item prop="project_declaration">
                  <el-checkbox-group v-model="declarationForm.project_declaration">
                    <el-checkbox v-for="item5 of declarationList" :label="item5.label"
                                 :value="item5.value"></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-form>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div class="declaration-menu">
          <el-descriptions class="margin-top" :column="1" border>
            <el-descriptions-item>
              <template slot="label">
                企业对科技服务<br/>方面的需求<span class="small-title">（多选）</span>
              </template>
              <el-form :model="declarationForm" :rules="rules" ref="declarationForm8" class="declarationForm2">
                <el-form-item prop="technology_service">
                  <el-checkbox-group v-model="declarationForm.technology_service">
                    <el-checkbox v-for="item6 of technologyList" :label="item6.label"
                                 :value="item6.value"></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-form>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div class="declaration-menu">
          <el-descriptions class="margin-top" :column="1" border>
            <el-descriptions-item>
              <template slot="label">
                企业对品牌服务<br/>方面的需求<span class="small-title">（多选）</span>
              </template>
              <el-form :model="declarationForm" :rules="rules" ref="declarationForm9" class="declarationForm2">
                <el-form-item prop="brand_service">
                  <el-checkbox-group v-model="declarationForm.brand_service">
                    <el-checkbox v-for="item7 of brandList" :label="item7.label" :value="item7.value"></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-form>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div class="declaration-menu">
          <el-descriptions class="margin-top" :column="1" border>
            <el-descriptions-item>
              <template slot="label">
                企业对法律服务<br/>方面的需求<span class="small-title">（多选）</span>
              </template>
              <el-form :model="declarationForm" :rules="rules" ref="declarationForm10" class="declarationForm2">
                <el-form-item prop="law_service">
                  <el-checkbox-group v-model="declarationForm.law_service">
                    <el-checkbox v-for="item9 of lawList" :label="item9.label" :value="item9.value"></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-form>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div class="declaration-menu">
          <el-descriptions class="margin-top" :column="1" border>
            <el-descriptions-item>
              <template slot="label">
                企业对云计算服务<br/>方面的需求<span class="small-title">（多选）</span>
              </template>
              <el-form :model="declarationForm" :rules="rules" ref="declarationForm11" class="declarationForm2">
                <el-form-item prop="cloud_computing_service">
                  <el-checkbox-group v-model="declarationForm.cloud_computing_service">
                    <el-checkbox v-for="item8 of cloudComputingList" :label="item8.label"
                                 :value="item8.value"></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-form>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div class="declaration-menu">
          <el-descriptions class="margin-top" :column="1" border>
            <el-descriptions-item>
              <template slot="label">
                企业对融资<br/>方面的需求<span class="small-title">（多选）</span>
              </template>
              <el-form :model="declarationForm" :rules="rules" ref="declarationForm12" class="declarationForm2">
                <el-form-item prop="financing">
                  <el-checkbox-group v-model="declarationForm.financing">
                    <el-checkbox v-for="item10 of financingList" :label="item10.label"
                                 :value="item10.value"></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-form>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div class="declaration-menu">
          <el-descriptions class="margin-top" :column="1" border>
            <el-descriptions-item>
              <template slot="label">
                企业对用能节能<br/>服务方面的需求<span class="small-title">（多选）</span>
              </template>
              <el-form :model="declarationForm" :rules="rules" ref="declarationForm13" class="declarationForm2">
                <el-form-item prop="energy">
                  <el-checkbox-group v-model="declarationForm.energy">
                    <el-checkbox v-for="item11 of energyList" :label="item11.label" :value="item11.value"></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-form>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div class="declaration-menu">
          <el-descriptions class="margin-top" :column="1" border>
            <el-descriptions-item>
              <template slot="label">
                企业对智能智造服务<br/>方面的需求<span class="small-title">（多选）</span>
              </template>
              <el-form :model="declarationForm" :rules="rules" ref="declarationForm14" class="declarationForm2">
                <el-form-item prop="intelligence">
                  <el-checkbox-group v-model="declarationForm.intelligence">
                    <el-checkbox v-for="item12 of intelligenceList" :label="item12.label"
                                 :value="item12.value"></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-form>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div class="declaration-menu">
          <el-descriptions class="margin-top" :column="1" border>
            <el-descriptions-item>
              <template slot="label">
                企业对高质量发展培<br/>育服务方面的需求<span class="small-title">（多选）</span>
              </template>
              <el-form :model="declarationForm" :rules="rules" ref="declarationForm15" class="declarationForm2">
                <el-form-item prop="cultivation">
                  <el-checkbox-group v-model="declarationForm.cultivation">
                    <el-checkbox v-for="item13 of cultivationList" :label="item13.label"
                                 :value="item13.value"></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-form>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <el-button type="primary" @click="submitDeclaration">提交</el-button>
      </div>
    </div>
    <home_footer/>
    <Hang/>
  </div>
</template>

<script>
import headerIndex from "@/components/header/headerIndex";
import home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hang";
import {isMobile} from "@/common/tools";
import {outsourcingIndustryList} from "@/api/cloudServiceApi";
import {add} from '@/api/customerSystemApi'
export default {
  name: "index",
  components: {headerIndex, home_footer, Hang},
  data() {
    const checkPhone = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请输入联系电话'));
      } else if (!isMobile(value)) {
        callback(new Error('请输入正确的手机号'));
      } else {
        callback();
      }
    }
    return {
      min_height: document.documentElement.clientHeight - 315,
      childNode: {},
      cid: 0,
      pName: '',
      backIndex: 0,
      declarationForm: {
        name: '',
        contacts: '',
        phone: '',
        industry: [],
        address: '',
        identity: '',
        taxation: [],
        knowledge: [],
        qualifications: [],
        personnel_matters: [],
        project_declaration: [],
        technology_service: [],
        brand_service: [],
        law_service: [],
        cloud_computing_service: [],
        financing: [],
        energy: [],
        intelligence: [],
        cultivation: [],
      },
      identityList: [
        {label: '普通员工', value: '普通员工'},
        {label: '法定代表人', value: '法定代表人'},
        {label: '股东', value: '股东'},
        {label: '董事', value: '董事'},
      ],
      industryList: [],
      taxationList: [
        {label: '代理记账', value: '代理记账'},
        {label: '工商代办', value: '工商代办'},
        {label: '审计服务', value: '审计服务'},
        {label: '税务代办', value: '税务代办'}
      ],
      knowledgeList: [
        {label: '商标登记注册', value: '商标登记注册'},
        {label: '专利申请', value: '专利申请'},
        {label: '版权申请登记', value: '版权申请登记'},
        {label: '软件著作权申请', value: '软件著作权申请'},
        {label: '国际商标和专利申请', value: '国际商标和专利申请'},
      ],
      qualificationsList: [
        {label: '许可证', value: '许可证'},
        {label: '专业承包资质', value: '专业承包资质'},
        {label: '建筑资质', value: '建筑资质'},
        {label: '认证资质', value: '认证资质'},
        {label: '管理体系资质', value: '管理体系资质'},
      ],
      mattersList: [
        {label: '社保和公积金服务', value: '社保和公积金服务'},
        {label: '人事培训和外包', value: '人事培训和外包'},
        {label: '工资代发', value: '工资代发'},
        {label: '人才招聘', value: '人才招聘'},
      ],
      declarationList: [
        {label: '申报材料撰写', value: '申报材料撰写'},
        {label: '专家指导', value: '专家指导'},
        {label: '材料递交', value: '材料递交'},
        {label: '项目培育', value: '项目培育'},
      ],
      technologyList: [
        {label: '网站开发', value: '网站开发'},
        {label: 'APP开发', value: 'APP开发'},
        {label: '小程序开发', value: '小程序开发'},
        {label: '企业应用程序开发', value: '企业应用程序开发'},
      ],
      brandList: [
        {label: 'logo设计', value: 'logo设计'},
        {label: '企业宣传品设计', value: '企业宣传品设计'},
        {label: 'VI设计', value: 'VI设计'},
        {label: '广告设计', value: '广告设计'},
        {label: '包装设计', value: '包装设计'},
        {label: 'PPT设计', value: 'PPT设计'},
      ],
      lawList: [
        {label: '法律咨询', value: '法律咨询'},
        {label: '法律顾问', value: '法律顾问'},
        {label: '法律服务', value: '法律服务'},
      ],
      cloudComputingList: [
        {label: '云计算基础', value: '云计算基础'},
        {label: '大数据', value: '大数据'},
        {label: '人工智能', value: '人工智能'},
        {label: '安全', value: '安全'},
        {label: '数据库', value: '数据库'},
      ],
      financingList: [
        {label: '500万以上-抵押贷', value: '500万以上-抵押贷'},
        {label: '500万以上-信用贷', value: '500万以上-信用贷'},
        {label: '500万以下-抵押贷', value: '500万以下-抵押贷'},
        {label: '500万以下-信用贷', value: '500万以下-信用贷'},
      ],
      energyList: [
        {label: '电力', value: '电力'},
        {label: '天然气', value: '天然气'},
        {label: '供水', value: '供水'},
      ],
      intelligenceList: [
        {label: '工业设计', value: '工业设计'},
        {label: '工业APP', value: '工业APP'},
        {label: '工业互联网', value: '工业互联网'},
        {label: '解决方案', value: '解决方案'},
      ],
      cultivationList: [
        {label: '融资贷款培育', value: '融资贷款培育'},
        {label: '企业信用培育', value: '企业信用培育'},
        {label: '数字化应用培育', value: '数字化应用培育'},
        {label: '知识产权培育', value: '知识产权培育'},
        {label: '科技能力培育', value: '科技能力培育'},
        {label: '市场推广培育', value: '市场推广培育'},
        {label: '政策奖补培育', value: '政策奖补培育'},
        {label: '法律风险控制培育', value: '法律风险控制培育'},
      ],
      rules: {
        name: [
          {required: true, message: '请输入企业名称', trigger: 'blur'},
          {min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur'}
        ],
        contacts: [
          {required: true, message: '请输入联系人', trigger: 'blur'},
          {min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur'}
        ],
        phone: [
          {required: true, validator: checkPhone, trigger: 'blur'}
        ],
        industry: [
          {required: true, message: '请选择所属行业', trigger: 'change'}
        ],
        address: [
          {required: true, message: '请输入联系地址', trigger: 'blur'},
          {min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur'}
        ],
        business_scope: [
          {required: true, message: '请输入主营业务范围', trigger: 'blur'},
          {min: 2, max: 1000, message: '长度在 2 到 1000 个字符', trigger: 'blur'}
        ],
        taxation: [
          {type: 'array', required: true, message: '企业对工商财税方面的需求至少选择一类', trigger: 'change'}
        ],
        knowledge: [
          {type: 'array', required: true, message: '企业对知识产权方面的需求至少选择一类', trigger: 'change'}
        ],
        identity: [
          {required: true, message: '请选择填写人的身份', trigger: 'change'}
        ],
        qualifications: [
          {type: 'array', required: true, message: '企业对资质办理方面的需求至少选择一类', trigger: 'change'}
        ],
        personnel_matters: [
          {type: 'array', required: true, message: '企业对人事服务方面的需求至少选择一类', trigger: 'change'}
        ],
        project_declaration: [
          {type: 'array', required: true, message: '企业对项目申报方面的需求至少选择一类', trigger: 'change'}
        ],
        technology_service: [
          {type: 'array', required: true, message: '企业对科技服务方面的需求至少选择一类', trigger: 'change'}
        ],
        brand_service: [
          {type: 'array', required: true, message: '企业对品牌服务方面的需求至少选择一类', trigger: 'change'}
        ],
        law_service: [
          {type: 'array', required: true, message: '企业对法律服务方面的需求至少选择一类', trigger: 'change'}
        ],
        cloud_computing_service: [
          {type: 'array', required: true, message: '企业对云计算服务方面的需求至少选择一类', trigger: 'change'}
        ],
        financing: [
          {type: 'array', required: true, message: '企业对融资方面的需求至少选择一类', trigger: 'change'}
        ],
        energy: [
          {type: 'array', required: true, message: '企业对用能节能服务方面的需求至少选择一类', trigger: 'change'}
        ],
        intelligence: [
          {type: 'array', required: true, message: '企业对智能智造服务方面的需求至少选择一类', trigger: 'change'}
        ],
        cultivation: [
          {type: 'array', required: true, message: '企业对高质量发展培育服务方面的需求至少选择一类', trigger: 'change'}
        ],
      },
    }
  },
  methods: {
    /*获取行业分类*/
    getOutsourcingIndustryList() {
      outsourcingIndustryList().then(res => {
        if (res.code == 200) {
          for (let list of res.content) {
            let item = {value: list.name, label: list.name, children: []};
            if (list.sonList.length > 0) {
              for (let son of list.sonList) {
                let son_list = {pid: son.pid, value: son.name, label: son.name, children: []}
                if (son.sonList.length > 0) {
                  for (let sons of son.sonList) {
                    let sons_list = {pid: sons.pid, value: sons.name, label: sons.name}
                    son_list.children.push(sons_list);
                  }
                }
                item.children.push(son_list);
              }
            }
            this.industryList.push(item);
          }
        }
      })
    },
    /*提交*/
    submitDeclaration() {
      let can = 0, formData = {};
      for (let a = 1; a < 16; a++) {
        this.$refs['declarationForm' + a].validate((valid) => {
          if (valid) {
          } else {
            can++;
            return false;
          }
        });
      }
      if (can == 0) {
        formData = {
          brandServicesDemand: this.declarationForm.brand_service.join(','),
          businessFinanceDemand: this.declarationForm.taxation.join(','),
          cloudServiceDemand: this.declarationForm.cloud_computing_service.join(','),
          companyName: this.declarationForm.name,
          energySavingDemand: this.declarationForm.energy.join(','),
          fillerName: this.declarationForm.identity,
          financingServicesDemand: this.declarationForm.financing.join(','),
          highQualityDevelopment: this.declarationForm.cultivation.join(','),
          industry: this.declarationForm.industry.join('-'),
          intellectualPropertyDemand: this.declarationForm.knowledge.join(','),
          intelligentManufacturingDemand: this.declarationForm.intelligence.join(','),
          legalServiceDemand: this.declarationForm.law_service.join(','),
          mainBusiness: this.declarationForm.business_scope,
          managerName: this.declarationForm.contacts,
          managerPhone: this.declarationForm.phone,
          personnelServiceDemand: this.declarationForm.personnel_matters.join(','),
          projectReportDemand: this.declarationForm.project_declaration.join(','),
          provinceCode: this.childNode.parentCityCode,
          qualificationDemand: this.declarationForm.qualifications.join(','),
          technologyServiceDemand: this.declarationForm.technology_service.join(','),
          unitAddress: this.declarationForm.address,
          cityCode:this.childNode.cityCode,
        };
        console.log(formData);
        add({data:JSON.stringify(formData)}).then(res=>{
          if (res.code==200){
            this.$message.success('提交成功');
          }else{
            this.$message.error('提交失败');
          }
        })
      }
    }
  },
  beforeMount() {
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    this.pName = this.$route.query.pName;
    this.backIndex = this.$route.query.backIndex;
    if (sessionStorage.getItem('childNode')) {
      this.childNode = JSON.parse(sessionStorage.getItem('childNode'));
    }
    this.getOutsourcingIndustryList();
  }
}
</script>
<style scoped>
.declaration-container >>> .declaration-content .declaration-breadcrumb .el-breadcrumb__separator[class*=icon] {
  margin: 0 0px;
  font-family: 'SourceHanSansCN';
  color: #5D5D5D;
}

.declaration-container >>> .declaration-content .declaration-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner,
.declaration-container >>> .declaration-content .declaration-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.declaration-container >>> .declaration-content .declaration-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.declaration-container >>> .declaration-content .declaration-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 100;
  color: #5D5D5D;
  font-family: 'SourceHanSansCN';
}

.declaration-container >>> .declaration-content .declaration-breadcrumb .el-breadcrumb {
  font-size: 14px;
  line-height: normal;
}

.declaration-container >>> .declaration-content .declaration-breadcrumb .el-breadcrumb__inner a,
.declaration-container >>> .declaration-content .declaration-breadcrumb .el-breadcrumb__inner.is-link {
  font-weight: 100;
  color: #333333;
}

.declaration-container >>> .declaration-content .declaration-info .declaration-menu .el-form-item__label {
  padding: 0 10px 0px;
  font-size: 18px;
}

.declaration-container >>> .declaration-content .declaration-info .declaration-menu .el-descriptions-item__label.is-bordered-label {
  background: #fafafa;
  font-size: 18px;
  font-family: "SourceHanSansCN";
  color: #333333;
  width: 232px;
  padding: 20px 10px 20px 20px !important;
}

.declaration-container >>> .declaration-content .declaration-info .declaration-menu .el-descriptions .is-bordered .el-descriptions-item__cell {
  border: 1px solid #DDDDDD;
  padding: 20px 30px 20px 20px;
  background: #F9F9F9;
}

.declaration-container >>> .declaration-content .declaration-info .declaration-menu .el-radio {
  min-width: 170px;
}

.declaration-container >>> .declaration-content .declaration-info .declaration-menu .el-checkbox__label {
  color: #333333;
  font-size: 18px;
  cursor: pointer;
  user-select: none;
  margin-right: 30px;
}

.declaration-container >>> .declaration-content .declaration-info .declaration-menu .el-radio__label {
  color: #333333;
  font-size: 18px;
  cursor: pointer;
}

.declaration-container >>> .declaration-content .declaration-info .declaration-menu .el-radio__inner {
  width: 18px;
  border: 1px solid #666666;
  height: 18px;
}

.declaration-container >>> .declaration-content .declaration-info .declaration-menu .el-radio__input.is-checked .el-radio__inner {
  border-color: #1637FF;
  background: #1637FF;
}

.declaration-container >>> .declaration-content .declaration-info .declaration-menu .el-checkbox__input.is-checked .el-checkbox__inner {
  border-color: #1637FF;
  background: #1637FF;
}

.declaration-container >>> .declaration-content .declaration-info .declaration-menu .el-checkbox__inner {
  width: 18px;
  border: 1px solid #666666;
  height: 18px;
}

.declaration-container >>> .declaration-content .declaration-info .declaration-menu .el-checkbox__inner::after {
  border-width: 2px;
  height: 12px;
  left: 5px;
  top: 0px;
}

.declaration-container >>> .declaration-content .declaration-info .declaration-menu .el-checkbox {
  min-width: 170px;
}

.declaration-container >>> .declaration-content .declaration-info .el-button--primary {
  color: #FFF;
  background-color: #1637FF;
  border-color: #1637FF;
  padding: 15px 55px;
  margin-top: 35px;
  font-size: 18px;
  font-family: 'SourceHanSansCN';
}

.declaration-container >>> .declaration-content .declaration-info .el-form-item__error {
  color: #FD2F37;
}
</style>
<style scoped lang="scss">
.declaration-container {
  background: #E7E9F5;

  .declaration-content {
    .declaration-breadcrumb {
      display: flex;
      justify-content: left;
      font-size: 14px;
      font-weight: 100;
      color: #333333;
      font-family: "SourceHanSansCN";
      padding: 10px 18%;
      min-width: 76rem;
      background: #E7E9F5;
    }

    .declaration-info {
      background: #ffffff;
      padding: 30px 18%;
      min-width: 76rem;
      .declaration-title {
        font-size: 24px;
        font-family: 'SourceHanSansCN';
        color: #333333;
        margin-block-start: 0px;
        cursor: pointer;
      }

      .declaration-tips {
        color: #999999;
        font-size: 16px;
        font-family: "SourceHanSansCN";
        line-height: 30px;
        cursor: pointer;
        margin-block-end: 30px;
      }

      .declaration-menu {
        background: #F9F9F9;
        align-items: center;
        margin-bottom: 10px;

        .small-title {
          color: #666666;
          font-size: 14px;
        }

        .declarationForm {
          .el-form-item {
            margin-bottom: 20px;
          }
        }

        .declarationForm2 {
          padding-left: 20px;

          .el-form-item {
            margin-bottom: 0px;
          }
        }
      }
    }
  }
}
</style>